<template>
    <section v-if="pageLoader">
        <div class="page-loader">{{ $t("loading.loading") }}</div>
    </section>
    <section v-else-if="!userIsEmpty('user')" class="puzzles puzzles-my">
        <div class="block-header block-header-dark">
            <div class="container-mobile">
                <ul class="tabs tabs-dark">
                    <div class="tabs-item tabs-current">
                        {{ $t("myPuzzles.myPuzzles") }}
                    </div>
                    <router-link tag="li" :to="{ name: 'puzzles' }" class="tabs-item">
                        <a class="link-inherit">
                            {{ $t("myPuzzles.myShopping") }}
                        </a>
                    </router-link>
                </ul>
            </div>
        </div>

        <div class="puzzles-info-block container-mobile">

            <span v-if="!editingMode" @click="toggleEditingMode" class="link link-puzzles" style="margin-right: 18px">
                {{ $t("myPuzzles.editPuzzles") }}
            </span>

            <span v-if="editingMode" class="link-puzzles">
                <span @click="cancelSelection" class="link" style="margin-right: 18px">
                    {{ $t("myPuzzles.undoEditing") }}
                </span>
                <span v-if="selected.length > 0" @click="removePuzzles(selected)" class="link">
                    {{ $t("myPuzzles.delete") }}
                </span>
            </span>

            <div class="buttons-row">
                <button @click="$modal.show('upload-photos', { puzzles: true })" class="button"
                    :disabled="isDownloadButtonDisabled">
                    {{ $t("myPuzzles.downloadPuzzle") }}
                </button>
            </div>

            <div v-if="myPuzzlesIsEmpty('puzzles')" class="text">
                {{ $t("myPuzzles.thePuzzleListRmpty") }}
            </div>
            <div v-else class="puzzles-list">
                <div v-for="(myPuzzle, index) in myPuzzles" :key="myPuzzle.id" :ref="'element' + index"
                    class="puzzles-item puzzles-item-my" :class="'element' + index">
                    <MyPuzzlesItem :myPuzzle="myPuzzle" :index="index" @remove="removePuzzles([myPuzzle.id])"
                        :editingMode="editingMode" :cancelSelection="cancelSelection">
                    </MyPuzzlesItem>
                </div>
            </div>
        </div>
    </section>
    <section v-else class="no-auth">
        {{ $t("auth.noAuth") }}
        <router-link class="link" tag="a" :to="{ name: 'home' }">
            {{ $t("auth.noAuthLink") }}
        </router-link>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import MyPuzzlesItem from "@/components/Blocks/MyPuzzlesItem";
import { observeListEnd } from "@/mixins/observeListEnd";

export default {
    name: "MyPuzzles",
    props: {
        i18n: Object,
    },
    mixins: [observeListEnd],
    components: {
        MyPuzzlesItem,
    },
    data() {
        return {
            pageLoader: true,
            moreLoader: false,
            moreIndex: 0,
            observer: null,
            editingMode: false,
            isSelectedClassEnabled: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userIsEmpty: "user/isEmpty",
            myPuzzles: "myPuzzles/fetchMyPuzzles",
            myPuzzlesErrors: "myPuzzles/errors",
            myPuzzlesIsEmpty: "myPuzzles/isEmpty",
            next: "myPuzzles/fetchMyPuzzlesNext",
            count: "myPuzzles/fetchMyPuzzlesCount",
            selected: "myPuzzles/fetchMyPuzzlesSelected",
        }),
        album() {
            for (let i in this.albums) {
                if (this.albums[i].album_type == 2) {
                    return this.albums[i];
                }
            }
        },
        isDownloadButtonDisabled() {
            return this.editingMode;
        }
    },
    created() {
        this.get();
        this.observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting === true) {
                    this.showMore();
                }
            },
            { threshold: [0] }
        );
    },
    methods: {
        get() {
            this.$store
                .dispatch("myPuzzles/get")
                .then(() => {
                    this.pageLoader = false;
                    this.updateMoreIndex();
                    this.observeListEnd("element");
                })
                .catch(() => {
                    this.pageLoader = false;
                });
        },
        removePuzzles(arr, callback = false) {
            this.$modal.show("dialog", {
                title: this.$t("threads.warning"),
                text: this.$t("myPuzzles.puzzlesRemoved"),
                buttons: [
                    {
                        title: this.$t("myPuzzles.delete"),
                        handler: () => {
                            this.$store
                                .dispatch("myPuzzles/delete", arr)
                                .then(() => {
                                    this.$modal.hide("dialog");
                                    if (callback) {
                                        callback();
                                    }
                                })
                                .catch(() => {
                                    this.$modal.hide("dialog");
                                });
                        },
                    },
                    {
                        title: this.$t("stories.cancel"),
                    },
                ],
            });
        },
        updateMoreIndex() {
            this.moreIndex = this.myPuzzles.length - 2;
        },
        showMore() {
            if (this.next) {
                this.moreLoader = true;
                this.$store
                    .dispatch("myPuzzles/getNext")
                    .then(() => {
                        this.observeListEnd("element", false, true, true);
                        this.moreLoader = false;
                        this.setProgress();
                    })
                    .catch(() => {
                        this.moreLoader = false;
                    });
            } else {
                this.observeListEnd("element", false, true);
            }
        },
        toggleEditingMode() {
            this.editingMode = !this.editingMode;
        },

        cancelSelection() {
            this.editingMode = false;
            this.selected = [];
            this.$store.dispatch('myPuzzles/clearSelected');
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_tabs";
@import "~@/assets/styles/pages/_puzzles";

.link-puzzles {
    display: block;
    text-align: end;
    margin-bottom: 12px;
}
</style>
